<template>
  <v-dialog v-model="localValue" max-width="500" lazy>
    <v-card>
      <v-toolbar color="primary" flat dense card dark>
        <v-toolbar-title>
          {{ $t('titles.global.confirmation') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="localValue = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <span class="subheading" v-html="text" />
        <span class="subheading" v-html="textInfo" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <meta-button type="cancel" @click="localValue = false" />

        <v-btn small color="primary" @click="submit">
          {{ $t('action.buttons.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogConfirm',
  props: {
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    text: {
      type: String,
      required: false,
      default: '',
    },
    textInfo: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return { localDialog: false }
  },
  computed: {
    localValue: {
      get() {
        return this.value || this.localDialog
      },
      set(value) {
        this.$emit('input', false)
        this.localDialog = value
      },
    },
  },
  methods: {
    submit() {
      this.$emit('submit')
      this.close()
    },
    show() {
      this.localValue = true
    },
    close() {
      this.localValue = false
    },
  },
}
</script>
